import {ScrollLock} from '../utils/scroll-lock';

const scrollLock = new ScrollLock();

const initPayment = () => { // далее сюда приходят формы из main.js

  const form = document.querySelector('.payment form');
  // const forms = document.querySelectorAll("forms") тут выбираем все формы, которые пришли, куда надо вешать показ loader
  let success = true;

  // const body = document.getElementsByTagName('body')[0];
  const loader = document.querySelector('.loader');
  const loaderTextLoad = document.querySelector('.loader__text-load');
  const loaderText = document.querySelector('.loader__text-process');
  const formInputs = document.querySelectorAll('.payment input');
  const formButton = document.querySelector('.payment button');
  const paymentSection = document.querySelector('.payment__data');

  if (paymentSection) { // проверку кнопки делаем только для секции paymentSection,а не для всей функции при передаче нескольких форм сверху)
    formButton.disabled = true;
    const enableFormButton = () => {
      formInputs.forEach((item) => {
        if (item.checked === true) {
          formButton.disabled = false;
        }
      });
    };

    formInputs.forEach((item) => { // при нескольких формамх эта функция будет работать только в секции payment
      item.addEventListener('click', enableFormButton);
    });


    const showModal = (evt) => {
      evt.preventDefault();
      if (formInputs) {
        formInputs.forEach((item) => {
          item.checked = false;
        });
      }
      loader.classList.remove('isHidden');
      loader.classList.add('isActiveLogin');
      window.disableBodyScroll();
      setTimeout(() => {
        loaderText.classList.remove('isHidden');
        loaderTextLoad.classList.add('isHidden');
        setTimeout(() => {
          if (success) {
            document.location.href = 'payment-success-var.html';
          } else {
            document.location.href = 'payment-failure-var.html';
          }
          setTimeout(() => {
            loaderText.classList.add('isHidden');
            loaderTextLoad.classList.remove('isHidden');
            window.enableBodyScroll();
          }, 1000);
        }, 3000);
      }, 3000);
    };

    form.addEventListener('submit', showModal);

    // forms.forEach((item) => {
      // item.addEventListener('submit', showModal);
    // });

    // здесь мы можем на все формы повесить показ loader и не забыть добавить в разметку определенного блока скрытый loader (можно этого не делать, если писать все блоки и их появление для каждой формы через js)
  }
};


export {initPayment};
